import React, { Component } from 'react';
import { Button, Grid, Row } from 'react-bootstrap';
import DatePicker from 'react-date-picker';
import LoaderButton from '../components/LoaderButton';
import SingleStop from '../components/ProdReport/SingleStop';
import yyyymmdd from '../libs/date_convert';
import { invokeApig } from '../libs/awsLib';

export default class ViewProdReport extends Component {
  constructor(props) {
    super(props);
    this.file = null;
    this.state = {
      isLoading: false,
      showPicker: true,
      reportData: {},
      currentDate: new Date(),
      searchDate: yyyymmdd(new Date()),
    };
    this.handleDateChangeV2 = this.handleDateChangeV2.bind(this);
    this.showDatePicker = this.showDatePicker.bind(this);
    this.getForecastData = this.getForecastData.bind(this);
  }

  async getForecastData() {
    try {
      const test = await invokeApig({
        path: `/pars/report/${this.state.searchDate}`,
        method: 'GET',
      });

      this.setState({
        isLoading: false,
        reportData: JSON.parse(test.body),
        showPicker: false,
      });
    } catch (e) {
      console.error(e);
    }
  }

  handleDateChangeV2(value) {
    this.setState({
      searchDate: yyyymmdd(value),
      currentDate: value,
    });
  }

  showDatePicker() {
    this.setState({
      showPicker: !this.state.showPicker,
    });
  }

  render() {
    let rows = [];
    const sums = {
      location: 'Summary',
      data_ids: {},
    };
    const keys = Object.keys(this.state.reportData);
    const data_array = this.state.reportData;
    for (let i = 0; i < keys.length; i++) {
      const skus = Object.keys(data_array[keys[i]].data_ids);
      for (let j = 0; j < skus.length; j++) {
        const sku = skus[j];
        if (Object.keys(sums.data_ids).indexOf(sku) === -1) {
          sums.data_ids[sku] = 0;
        }
        sums.data_ids[sku] += parseInt(data_array[keys[i]].data_ids[sku], 10);
      }
    }

    if (Object.keys(data_array).length > 0) {
      data_array.push(sums);
      rows = data_array.map((route_stop) => (
        <div key={route_stop.location}>
          <div id="driver-title">
            <strong>{route_stop.location}</strong>
          </div>
          <p />
          <div id="driver-name">
            <strong>{route_stop.driver}</strong>
          </div>
          <p />
          <SingleStop data={route_stop.data_ids} />
        </div>
      ));
    } else {
      rows = [];
    }

    return (
      <div>
        {!this.state.showPicker && (
          <LoaderButton
            block
            bsStyle="primary"
            bsSize="large"
            onClick={this.showDatePicker}
            type="submit"
            isLoading={this.state.isLoading}
            text="Choose Another Date"
            loadingText="Loading Locations…"
          />
        )}
        {this.state.showPicker && (
          <Grid style={{ minHeight: '100vh' }}>
            <Row className="text-center" style={{ marginBottom: '15px' }}>
              <DatePicker
                onChange={this.handleDateChangeV2}
                value={this.state.currentDate}
              />
            </Row>
            <Row className="text-center">
              <Button
                bsStyle="primary"
                bsSize="large"
                onClick={this.getForecastData}
              >
                Search
              </Button>
            </Row>
          </Grid>
        )}
        <hr />
        <p style={{ pageBreakBefore: 'always' }} />
        <p />
        <div key="data" style={{ fontSize: 'large' }}>
          {!this.state.isLoading && rows}
        </div>
      </div>
    );
  }
}
